import { render, staticRenderFns } from "./companySaleSettingsCreateModal.vue?vue&type=template&id=028f0bec&"
import script from "./companySaleSettingsCreateModal.vue?vue&type=script&lang=ts&"
export * from "./companySaleSettingsCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports